import { Message } from "../../domain/entities/message";
import { EquipmentType } from "../../domain/entities/equipment-type";
import { httpClient } from "../axios/axios-api";

class EquipmentTypeRepository {
  async getAll(filter: any): Promise<Message<EquipmentType[]>> {
    const response = await httpClient.get("/equipmentType", { params: filter });
    return response.data;
  }

  async create(input: EquipmentType): Promise<Message<EquipmentType>> {
    const response = await httpClient.post("/equipmentType", { data: input });
    return response.data;
  }

  async update(input: EquipmentType): Promise<Message<boolean>> {
    const response = await httpClient.put(`/equipmentType/${input.id}`, { data: input });
    return response.data;
  }

  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/equipmentType/${id}`);
    return response.data;
  }
}

export default new EquipmentTypeRepository();
